import React from "react";
import { Helmet } from "react-helmet";

/**
 * Renders a schema.org JSON-LD block into <head>. Builders for the data
 * objects live in helpers/structuredData.js. Renders nothing for falsy data,
 * so callers can pass builder output straight through without guarding.
 */
const JsonLd = ({ data }) => {
    if (!data) return null;
    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(data)}</script>
        </Helmet>
    );
};

export default JsonLd;
